import React,{useRef,useState} from "react";
import classes from './Login.module.css';
import {useLocation,Redirect} from 'react-router-dom';
import axios from "axios";
import AuthLogo from '../../assets/authentication.jpg';
import AuthProgressLogo from '../../assets/authprogress.gif';

const Login =()=>{
    // const ApiUrl = "http://demo.autozilla.co/";
    // const AppUrl = "http://localhost:3000/";

    // const ApiUrl = "https://preprod.autozilla.co/";
    // const AppUrl = "https://preprod.autozilla.co/";

    const ApiUrl = "https://app.autozilla.co/";
    const AppUrl = "https://app.autozilla.co/";

    const [token,SetToken] = useState(false);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const secretkey = queryParams.get('key');
    const userKey = queryParams.get('user_key'); 
    const salesKey = queryParams.get('sales_key'); 
  //console.log(salesKey);return false;
if((secretkey!=null && secretkey!='') || (userKey!=null && userKey!='') || (salesKey!=null && salesKey!='')){
  const userJson = {
    AppKey:secretkey,
    userKey : userKey,
    salesKey : salesKey,
    Appusername : '',
    Apppassword : ''
  }
  // console.log(userJson);
  axios.post(ApiUrl+`pos/api/Auth`,userJson,{
    auth: {username:'az_live@autozilla.com',
          password:'4cslC166sb2A63FmO7Jh65z0N3Zh1ZL8'},
headers : {           
    'Content-Type' : 'application/json'
}
}).then(res => {
    //console.log(res.data);
  if(res.data.user_id>0){
    SetToken(true);
    sessionStorage.setItem('user_id', res.data.user_id);
    sessionStorage.setItem('firstname', res.data.firstname);
    sessionStorage.setItem('lastname', res.data.lastname);
    sessionStorage.setItem('email', res.data.email);
    sessionStorage.setItem('phone', res.data.phone);
   window.location.href=AppUrl+'onboard';
  }else{
    sessionStorage.setItem('user_id', '');
    sessionStorage.setItem('firstname', '');
    sessionStorage.setItem('lastname', '');
    sessionStorage.setItem('email', '');
    sessionStorage.setItem('phone', '');
  }
});
}else{

}
   
    if(secretkey || userKey){
    return (
        <div className={classes.mainLogin}>
                    <div className="container-fluid">
                    <div className="row  mt-5">
                        <div className="col-sm-4 offset-sm-4 mt-4 mb-4">
                <img src= {AuthProgressLogo} alt='Auto Parts By Autozilla' className="w-100 auth_load"/>
                <p className="mt-3 text-center"><b>Authentication Inprogress...</b></p>
                </div>
                </div>
                </div>                    
                </div> 
    );
    }else{
       
        return (           
                <div className={classes.mainLogin}>
                    <div className="container-fluid">
                    <div className="row  mt-5">
                        <div className="col-sm-4 offset-sm-4 mt-4 mb-4">
                <img src= {AuthLogo} alt='Auto Parts By Autozilla' className="w-100"/>
                <p className="mt-3 text-center"><b>Authentication Required to access the Catalog</b></p>
                </div>
                </div>
                </div>                    
                </div>    
                
                
            );
    }
}

export default Login;